import React, { useState } from 'react';
import './CareersPage.css';
import '../../styles/accordion.css';
import Footer from '../../components/Footer/Footer';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import { HandDrawnButton } from '../../components/shared/HandDrawnButton/HandDrawnButton';

interface Job {
  id: string;
  title: string;
  location: string;
  type?: string;
}

const jobListings: Job[] = [
  { id: '1', title: 'Masajista', location: 'AWASI ATACAMA' },
  { id: '2', title: 'Recepcionist', location: 'AWASI ATACAMA' },
  { id: '3', title: 'Head Receptionist', location: 'AWASI ATACAMA' },
  { id: '4', title: 'Maitre', location: 'AWASI ATACAMA' },
  { id: '5', title: 'Housekeeping', location: 'AWASI ATACAMA' },
  { id: '6', title: 'Garzón', location: 'AWASI ATACAMA' },
  { id: '7', title: 'Analista de Administración Senior', location: 'AWASI ATACAMA' },
  { id: '8', title: 'Jefe de guías - Head Guide', location: 'AWASI ATACAMA' },
  { id: '9', title: 'Instrutor de mergulho', location: 'AWASI ATACAMA' },
  { id: '10', title: 'Guía de excursiones', location: 'AWASI ATACAMA' },
  { id: '11', title: 'Jefe/a de Pastelería', location: 'AWASI ATACAMA' },
  { id: '12', title: 'Subgerente', location: 'AWASI ATACAMA' },
  { id: '13', title: 'Asistente de mantenimiento', location: 'AWASI ATACAMA' },
];

const CareersPage: React.FC = () => {
  const [expandedJob, setExpandedJob] = useState<string | null>(null);
  const [selectedLocation, setSelectedLocation] = useState<string>('ATACAMA');
  const [selectedType, setSelectedType] = useState<string>('TYPE');

  const toggleJob = (jobId: string) => {
    setExpandedJob(expandedJob === jobId ? null : jobId);
  };

  return (
    <div className="careers-page">
      {/* Navigation */}
      <UnifiedNavigation variant="light" />
      
      {/* Hero Section with Diptych */}
      <div className="careers-hero">
        <div className="careers-hero-text">
          <div className="careers-hero-content">
            <h1>+300 people, +17 nationalities, Uncountable talents</h1>
            <p>Our staff create first impressions, accompany our guests on their adventures and strive to exceed expectations — sending them home with unforgettable memories. Our team is made of passionate people who are proud ambassadors of these lands. Each of them is a key component of the Awasi Lodges. We are forever grateful to the #AwasiFamily.</p>
          </div>
          <div className="careers-hero-image-small"></div>
        </div>
        <div className="careers-hero-image"></div>
      </div>

      {/* Job Opportunities Section */}
      <div className="careers-job-section">
        <div className="careers-cta-container">
          <h2>Join the Awasi Family</h2>
          <p>We are always looking for passionate individuals to join our team across all properties. Explore current opportunities and become part of our mission to create unforgettable experiences.</p>
          <HandDrawnButton
            text="VIEW POSITIONS"
            onClick={() => window.open('https://awasi.hiringroom.com/jobs', '_blank')}
            variant="brand"
            color="awasi"
            animation="stroke-to-fill"
            size="wide"
            className="careers-view-positions-btn"
          />
        </div>
      </div>

      {/* Full Video Section with Sound Button */}
      <div className="careers-video-section">
        <div className="careers-video">
          <button className="careers-sound-button" aria-label="Toggle sound">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M8 3L4 6H1V12H4L8 15V3Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M11 6C11.5 6.5 12 7.5 12 9C12 10.5 11.5 11.5 11 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

      {/* Team Section */}
      <div className="careers-team-section">
        <h2>+300 people, +17 nationalities,<br />Uncountable talents</h2>
        <HandDrawnButton
          text="MEET OUR TEAM"
          onClick={() => {}}
          variant="brand"
          color="awasi"
          animation="stroke-to-fill"
          size="wide"
          className="careers-meet-team-button"
        />
      </div>

      {/* Instagram Feed + Footer */}
      <InstagramSection />
      <Footer variant="default" />
    </div>
  );
};

export default CareersPage;